// =============================================
// SynFin Input Validation & Security Utilities
// =============================================

// Sanitise any user-supplied string to prevent XSS
export const sanitizeInput = (value) => {
  if (typeof value !== 'string') return '';
  return value.trim().replace(/[<>]/g, '');
};

// Validate email format
export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};

// Enforce password strength: min 8 chars, 1 uppercase, 1 number, 1 special char
export const validatePassword = (password) => {
  const errors = [];
  if (password.length < 8) errors.push('At least 8 characters');
  if (!/[A-Z]/.test(password)) errors.push('At least one uppercase letter');
  if (!/[0-9]/.test(password)) errors.push('At least one number');
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password))
    errors.push('At least one special character (!@#$%...)');
  return errors;
};

// Validate full name: only letters and spaces
export const validateFullName = (name) => {
  return /^[a-zA-Z\s'-]{2,60}$/.test(name.trim());
};

// Rate limit helper — returns true if action is allowed
// Stores attempt timestamps in sessionStorage (cleared on tab close)
export const checkRateLimit = (key, maxAttempts = 5, windowMs = 15 * 60 * 1000) => {
  const now = Date.now();
  const stored = JSON.parse(sessionStorage.getItem(key) || '[]');
  const recent = stored.filter((t) => now - t < windowMs);
  if (recent.length >= maxAttempts) return false;
  recent.push(now);
  sessionStorage.setItem(key, JSON.stringify(recent));
  return true;
};
